import Api from '../api'

const api = new Api().init()
const api_v2 = new Api(2).init()

const signin = (data) => {
  return api.post('/login', data)
}

const checkToken = (token) => {
  return api.get(`/check-token/${token}`)
}

const checkTokenV2 = (token) => {
  return api_v2.get(`/check-token/${token}`)
}

const logout = (token) => {
  return api.post(`/logout`, null, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const forgotPassword = (data) => {
  return api.post(`/forgot-password`, data)
}

const resetPassword = (data) => {
  return api.post(`/reset-password`, data)
}

const changePassword = (data) => {
  return api.patch(`/change-password`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const loginAs = (user_id) => {
  return api_v2.post(`/login-as`, {
    nama_pengguna: user_id,
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {signin, checkToken, logout, forgotPassword, resetPassword, changePassword, checkTokenV2, loginAs}
